module.exports = __webpack_public_path__ + "img/Suporte_Basico_de_Vida.faa85032.png";